require('./bootstrap');

window.bootstrap = require("bootstrap");
require("fslightbox");

// MOBILE MENU
document.querySelectorAll(".header__inner__right__navigation__menu__item__link").forEach((element) => {
    if (window.innerWidth < 1200) {
        if (element.nextElementSibling) {
            element.addEventListener("click", function (e) {
                e.preventDefault();
                let submenu = element.nextElementSibling;
                if (!submenu.classList.contains('active')) {
                    submenu.classList.add('active');
                    submenu.style.height = 'auto';
                    let height = (submenu.clientHeight + 10) + 'px';
                    submenu.style.height = '0px';
                    setTimeout(function () {
                        submenu.style.height = height;
                        submenu.style.paddingTop = '10px';
                        submenu.style.paddingBottom = '10px';
                    }, 0);
                } else {
                    submenu.style.height = '0px';
                    submenu.style.paddingTop = '0px';
                    submenu.style.paddingBottom = '0px';

                    submenu.addEventListener('transitionend', function () {
                        submenu.classList.remove('active');
                    }, {
                        once: true
                    });
                }
            });
        }
    }
});

// HEADER

const menuToggler = document.querySelector('.header__inner__right__bars');
const menuTogglerClose = document.querySelector('.header__inner__right__close');
const navigationMenu = document.querySelector('.header__inner__right__navigation');

menuToggler.addEventListener('click', function () {
    menuToggler.classList.toggle('active');
    navigationMenu.classList.toggle('active');
});

menuTogglerClose.addEventListener('click', function () {
    menuToggler.classList.remove('active');
    navigationMenu.classList.remove('active');
});

function adjustRows() {
    const rows = document.querySelectorAll('.fc-daygrid-body tr');
    let visibleRows = 0;

    rows.forEach(row => {
        const visibleDays = row.querySelectorAll('.fc-day:not(.fc-day-other)').length;
        if (visibleDays > 0) {
            visibleRows++;
            row.style.display = ''; // Mostrar fila si tiene días visibles
        } else {
            row.style.display = 'none'; // Ocultar filas sin días visibles
        }
    });

    if (visibleRows > 6) {
        // Aquí puedes hacer ajustes si hay más de 5 filas visibles
        // Por ejemplo, podrías cambiar el diseño o ajustar el espaciado
    }
}

// VIDEO
if (document.querySelector('.play-video')) {
    const play_video = document.querySelector('.play-video');
    const video = document.querySelector('.home-second-block__inner__content__right__video > video');
    play_video.addEventListener('click', function () {
        video.play();
        play_video.parentElement.classList.add('hidden');
    });
    video.addEventListener('click', function () {
        video.pause();
        play_video.parentElement.classList.remove('hidden');
    });
}

// SLIDER PRIMER BLOQUE
if (document.getElementById('next')) {
    const slides = document.querySelectorAll('.home-first-block__inner__right__slider__item');
    const button = document.getElementById('next');

    button.addEventListener('click', function () {
        let currentSlide = document.querySelector('.item-active');
        let nextSlide;

        if (currentSlide.nextElementSibling) {
            nextSlide = currentSlide.nextElementSibling;
        } else {
            nextSlide = slides[0];
        }

        if (nextSlide) {
            currentSlide.classList.remove('item-active');
            nextSlide.classList.add('item-active');
        }
    });
}

if (document.getElementById('events-calendar')) {
    const body = document.querySelector('html');
    const calendarModal = document.querySelector('.modal-calendar-events');

    document.addEventListener('DOMContentLoaded', function () {
        const eventsCalendarEl = document.getElementById('events-calendar');
        const calendar = new FullCalendar.Calendar(eventsCalendarEl, {
            initialView: 'dayGridMonth',
            firstDay: 1,
            showNonCurrentDates: false,
            buttonText: {
                today: 'Hoy', // Cambia el texto del botón "today",
                prev: 'Ant',
                next: 'Sig'
            },
            events: eventsCalendar,
            eventClick: function (info) {
                // Evita la navegación predeterminada (si hay algún enlace)
                info.jsEvent.preventDefault();
                axios.post('/ajax/listado-agenda', {
                    fecha: info.event.startStr
                }).then(function (response) {
                    document.querySelector('.modal-calendar-events__inner__content').innerHTML = response.data;
                    calendarModal.classList.add('active');
                    body.classList.add('no-scroll');
                }).catch(function (error) {
                    console.log(error);
                });
            }
        });
        calendar.render();
        calendar.setOption('locale', 'es');
    });

    document.querySelector('.modal-calendar-events__inner__close').addEventListener('click', function () {
        body.classList.remove('no-scroll');
        calendarModal.classList.remove('active');
    });

    window.addEventListener('keyup', function (e) {
        if (calendarModal.classList.contains('active') && e.key === 'Escape') {
            body.classList.remove('no-scroll');
            calendarModal.classList.remove('active');
        }
    });
}

if (document.querySelector('.home-fourth-block__inner__content__right')) {
    const divPhysicalClasses = document.querySelector('.home-fourth-block__inner__content__right');

    document.addEventListener('DOMContentLoaded', function () {
        divPhysicalClasses.innerHTML = '<i class="fas fa-spinner-third fa-spin me-1"></i> cargando datos...';
        axios.post('/ajax/aulas-fisicas', {
            comarca_id: comarcaId,
            comarca_titulo: comarcaTitulo
        }).then(function (response) {
            setInnerHTML(divPhysicalClasses, response.data);
        }).catch(function (error) {
            divPhysicalClasses.innerHTML = '<i class="fas fa-times me-1"></i> Se ha producido un error al cargar el mapa';
            console.log(error);
        });
    });

    document.querySelectorAll('[data-map-marker]').forEach(function (mapMarker) {
        mapMarker.addEventListener('click', function () {
            divPhysicalClasses.innerHTML = '<i class="fas fa-spinner-third fa-spin me-1"></i> cargando datos...';
            axios.post('/ajax/aulas-fisicas', {
                comarca_id: mapMarker.dataset.comarcaId,
                comarca_titulo: mapMarker.dataset.comarcaTitulo
            }).then(function (response) {
                setInnerHTML(divPhysicalClasses, response.data);
            }).catch(function (error) {
                divPhysicalClasses.innerHTML = '<i class="fas fa-times me-1"></i> Se ha producido un error al cargar el mapa';
                console.log(error);
            });
        });
    });
}

function setInnerHTML(elm, html) {
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll("script")).forEach(oldScriptEl => {
        const newScriptEl = document.createElement("script");
        Array.from(oldScriptEl.attributes).forEach(attr => {
            newScriptEl.setAttribute(attr.name, attr.value)
        });
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        newScriptEl.appendChild(scriptText);
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
    });
}

if (document.getElementById('formBoletin')) {
    document.getElementById('formBoletin').addEventListener('submit', function (event) {
        event.preventDefault();
        let formBoletinText = document.getElementById('formBoletinText');
        let emailNewsletter = document.getElementById('email_newsletter');
        formBoletinText.innerHTML = '<div class="alert alert-info px-3 py-1 mt-1"><i class="fas fa-spinner-third fa-spin me-1"></i> enviando datos...</div>';
        axios.post('/ajax/suscribir-boletin', {
            email: emailNewsletter.value
        }).then(function (response) {
            formBoletinText.innerHTML = response.data;
        }).catch(function (error) {
            console.log(error);
        });
    });
}

function scrollTo(element, to, duration) {
    if (duration <= 0) return;
    let difference = to - element.scrollTop;
    let perTick = difference / duration * 10;

    setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
    }, 10);
}

if (document.getElementById('todosMeses')) {
    document.getElementById('todosMeses').addEventListener('click', function () {
        let checkboxes = document.getElementsByName('meses[]');
        for (let checkbox of checkboxes) {
            checkbox.checked = this.checked;
        }
    });
}
if (document.getElementById('todasMaterias')) {
    document.getElementById('todasMaterias').addEventListener('click', function () {
        let checkboxes = document.getElementsByName('materias[]');
        for (let checkbox of checkboxes) {
            checkbox.checked = this.checked;
        }
    });
}

document.querySelectorAll('.ficha-evento').forEach(function (fichaCurso) {
    fichaCurso.addEventListener('click', function () {
        let modalFichaCurso = document.getElementById('modalFichaCurso');
        let modalBody = modalFichaCurso.getElementsByClassName('modal-body')[0];
        let modalCurso = new bootstrap.Modal(modalFichaCurso);
        modalCurso.show();
        modalBody.innerHTML = '<div class="d-flex align-items-center"><strong>Cargando contenido...</strong><div class="spinner-border ml-auto" role="status" aria-hidden="true"></div></div>';
        axios.post('/ajax/ficha-evento', {
            id: fichaCurso.dataset.id
        }).then(function (response) {
            setInnerHTML(modalBody, response.data);
        }).catch(function (error) {
            modalBody.innerHTML = '<div class="alert alert-danger text-center" role="alert">Se ha producido un error inesperado. Por favor, inténtelo de nuevo mas tarde.</div>';
            console.log(error);
        });
    });
});
